<template>
  <div>
    <div class="levelSelector">
      <select v-model="difficulty">
        <option>Practice</option>
        <option>Timer mode</option>
        <option>Hard mode</option>
      </select>
    </div>
    <button :disabled="!complete" @click="jumbleIt(jumbleNum)">
      Shuffle Cube
    </button>
    <div class="cube">
      <rubix-side
        :style="{ order: order[0] }"
        :right="right2"
        :up="up1"
        :toRotate="top"
        view="Top"
        color="Blue"
      />
      <br />
      <rubix-side
        :style="{ order: order[1] }"
        :right="right2"
        :up="up1"
        :toRotate="bottom"
        view="Bottom"
        :direction="false"
        :direction1="false"
        color="Green"
      />
      <br />
      <rubix-side
        :style="{ order: order[2] }"
        :right="right1"
        :up="up1"
        :toRotate="front"
        view="Front"
        color="Gray"
      />
      <br />
      <div class="break"></div>
      <rubix-side
        :style="{ order: order[3] }"
        :right="right1"
        :up="up1"
        :toRotate="back"
        :direction="false"
        :direction1="false"
        view="Back"
        color="Pink"
      />
      <br />
      <rubix-side
        :style="{ order: order[4] }"
        :right="right1"
        :up="up2"
        :toRotate="left"
        view="Left"
        color="Red"
      />
      <br />
      <rubix-side
        :style="{ order: order[5] }"
        :right="right1"
        :up="up2"
        :toRotate="right"
        :direction="false"
        view="Right"
        color="Yellow"
      />
    </div>
  </div>
</template>

<script>
import rubixSide from "./rubixSide";
import { bus } from "../main";
import confettiLauncher from "../utilities/confetti";
export default {
  name: "rubixCube",
  components: {
    "rubix-side": rubixSide,
  },
  data() {
    return {
      up1: ["Top", "Back", "Bottom", "Front"],
      up2: ["Left", "Top", "Right", "Bottom"],
      right1: ["Front", "Right", "Back", "Left"],
      right2: ["Top", "Right", "Bottom", "Left"],
      originalOrder: [1, 2, 3, 5, 6, 7],
      order: [1, 2, 3, 5, 6, 7],
      times: 5,
      difficulty: "Practice",
      shuffleOrder1: false,
      complete: false,
      top: {
        up: "Back",
        down: "Front",
        left: "Left",
        right: "Right",
      },
      front: {
        up: "Top",
        down: "Bottom",
        left: "Left",
        right: "Right",
      },
      bottom: {
        up: "Front",
        down: "Back",
        left: "Left",
        right: "Right",
      },
      back: {
        up: "Top",
        down: "Bottom",
        left: "Right",
        right: "Left",
      },
      left: {
        up: "Top",
        down: "Bottom",
        left: "Back",
        right: "Front",
      },
      right: {
        up: "Top",
        down: "Bottom",
        left: "Front",
        right: "Back",
      },
      jumbleNumber: 3,
    };
  },
  methods: {
    shuffleOrder() {
      if (this.shuffleOrder1) {
        console.log("Shuffled");
        this.order.sort(() => Math.random() - Math.random());
        this.callFunc();
      }
    },
    callFunc() {
      setTimeout(() => this.shuffleOrder(), this.times * 1000);
    },
    jumbleIt(jumbleNum) {
      let all = [...this.up1, ...this.up2, ...this.right1, ...this.right2];
      all = all.filter((item, pos) => all.indexOf(item) === pos);
      const randomSide = () => {
        //Giving a random side
        let sides = [...all];
        let toGive = sides.sort(() => Math.random() - Math.random());
        return toGive[0];
      };
      const jumbleCube = () => {
        //Jumbling the cube
        for (let i = 0; i < 3; i++) {
          const emitSide = randomSide();
          const emitEvent = emitSide + "Shuffle";
          bus.$emit(emitEvent);
          console.log(emitEvent);
        }
      };
      jumbleCube(jumbleNum);
    },
  },
  watch: {
    difficulty(newValue, oldValue) {
      if (newValue === "Timer mode") {
        this.shuffleOrder1 = true;
        this.shuffleOrder();
      } else if (newValue == "Hard mode") {
        this.jumbleNumber = 5;
        if (this.complete) {
          this.jumbleIt(this.jumbleNumber);
        }
        this.shuffleOrder1 = true;
        this.shuffleOrder();
      } else {
        this.shuffleOrder1 = false;
        this.order = this.originalOrder;
      }
    },
  },
  created() {
    setTimeout(() => this.shuffleOrder(), 1000 * this.times);
  },
  mounted() {
    let count = 0;
    let correctChecker = 0;
    let times = 0;
    let all = [...this.up1, ...this.up2, ...this.right1, ...this.right2];
    all = all.filter((item, pos) => all.indexOf(item) === pos);
    const randomSide = () => {
      //Giving a random side
      let sides = [...all];
      let toGive = sides.sort(() => Math.random() - Math.random());
      return toGive[0];
    };
    const jumbleCube = () => {
      //Jumbling the cube
      for (let i = 0; i < 3; i++) {
        const emitSide = randomSide();
        const emitEvent = emitSide + "Shuffle";
        bus.$emit(emitEvent);
        console.log(emitEvent);
      }
    };
    jumbleCube(this.jumbleNumber);
    //When a move is complete asking all sides to show their grids
    console.log({ all });
    bus.$on("Completed changing values", () => {
      times++;
      if (times == 4) {
        times = 0;
        for (let elem of all) {
          const side = "showGrid" + elem;
          bus.$emit(side);
        }
      }
    });
    bus.$on("grid", (result) => {
      count++;
      if (result) {
        correctChecker++;
      }
      if (count == 6 && correctChecker == 6) {
        count = 0;
        correctChecker = 0;
        confettiLauncher.launchConfettiFireWorks();
        this.complete = true;
      } else if (count == 6) {
        count = 0;
        correctChecker = 0;
      }
    });
  },
};
</script>

<style scope>
.cube {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 1;
  flex-grow: 1;
  justify-content: center;
  margin: auto;
}
.side {
  margin: 15px;
}
.break {
  width: 100%;
  order: 4;
}
</style>
